import { ERole } from '../../shared/enums/user/ERole';
import { adminRoutes } from './roles/adminRoutes';
import { developerRoutes } from './roles/developerRoutes';
import { userRoutes } from './roles/userRoutes';

export const routeList = [
  {
    role: ERole.DEVELOPER,
    routes: developerRoutes,
  },
  {
    role: ERole.ADMIN,
    routes: adminRoutes,
  },
  {
    role: ERole.USER,
    routes: userRoutes,
  },
];
